export default __webpack_public_path__ + "static/media/app-explore.eab9bd86.svg";